import { useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Translate } from 'react-redux-i18n'
import { useNavigate } from 'react-router'
import authProvider from '../../../../core/AuthenticationProvider'
import { Element } from '../../../common/html/element'
import { Image } from '../../../common/image'
import { Loading } from '../../../common/loading'
import EventEmitter, { SHOW_POPUP_ERROR } from '../../../helpers/EventEmitter'
import { checkEmailValid, checkPhoneValid } from '../../../helpers/validation'
import { selectUserType } from '../../../layout/store/slice'
import { COMPONENTS } from '../../../routers/constants'
import {
  resetStore as resetStoreScreening,
  selectDiscountInfo,
  selectLanguageCode,
  selectNumberOfCompany,
  selectScreeningPrice,
} from '../../../tool/screening/exportFileSetting/store/slice'
import { USER_TYPE } from '../../../utils/authorization'
import { TransferInformationPopup } from '../../common/poup/TransferInformationPopup'
import {
  CHECKBOX_TRADE_DISCOUNT,
  PAYMENT_METHOD,
  PAYMENT_METHOD_CODE,
  STEP,
  STYLE_DISABLE,
  TYPE_STATUS_ORDER,
} from '../../constant'
import { checkExistDataBlock } from '../../helper'
import classes from '../../index.module.scss'
import {
  changeFragment,
  resetStore,
  selectCheckDisCountAndVoucher,
  selectCheckIds,
  selectCheckRules,
  selectCodeBankTransfer,
  selectDataPlaceOrder,
  selectDisableOrder,
  selectDiscountOrder,
  selectFactSheetData,
  selectFactSheetId,
  selectLoading,
  selectParamsScreeningReport,
  selectUserInformationValue,
  selectVoucher,
} from '../../store/slice'
import { getBankTransferInfo, postOrder } from '../../store/thunk'
import chaseMoneyIcon from './chaseMoney.svg'

export const PlaceOrder = ({
  method,
  bankTransferType,
  isValid,
  setIsValid,
  isScreening,
  unitBank,
  setShowInvalidPackage,
}) => {
  const dispatch = useDispatch()
  const navigate = useNavigate()

  const [iShowInfoTransfer, setShowInfoTransfer] = useState(false)

  const locale = useSelector((state) => state.i18n.locale)
  const loadingPost = useSelector(selectLoading('postOrder'))
  const loadingBankTransfer = useSelector(selectLoading('getBankTransferInfo'))
  const userInfo = useSelector(selectUserInformationValue())
  const dataItemCart = useSelector(selectDataPlaceOrder)
  const voucher = useSelector(selectVoucher)
  const disableOrder = useSelector(selectDisableOrder)
  const isCheckTerm = useSelector(selectCheckRules)
  const discountOrder = useSelector(selectDiscountOrder)
  const { rawCriteria, ...paramsScreeningReport } = useSelector(
    selectParamsScreeningReport,
  )
  const numberCompany = useSelector(selectNumberOfCompany)
  const languageCode = useSelector(selectLanguageCode)
  const screeningPrice = useSelector(selectScreeningPrice)
  const discountInfo = useSelector(selectDiscountInfo)
  const dataBankTransfer = useSelector(selectCodeBankTransfer)
  const dataFactSheet = useSelector(selectFactSheetData)
  const factSheetId = useSelector(selectFactSheetId)
  const idCheck = useSelector(selectCheckIds)
  const userType = useSelector(selectUserType)
  const checkDiscountAndVoucher = useSelector(selectCheckDisCountAndVoucher)

  const factSheetIdCheck = factSheetId.filter((item) => idCheck.includes(item))

  const isExistDataBlock = checkExistDataBlock(dataFactSheet, factSheetIdCheck)
  const isFullCriteria =
    (isScreening && !!rawCriteria && !!paramsScreeningReport) || !isScreening

  const checkValidForm =
    method === PAYMENT_METHOD.PACKAGE
      ? true
      : Object.values(isValid).every(Boolean)
  const userInfoFormat = method === PAYMENT_METHOD.PACKAGE ? {} : userInfo
  let isDisable = false
  const isCheckRules = [
    PAYMENT_METHOD.PACKAGE,
    PAYMENT_METHOD.POST_PAID,
  ].includes(method)
    ? true
    : isCheckTerm
  const loadingOrder = loadingPost || loadingBankTransfer

  switch (method) {
    case PAYMENT_METHOD.PACKAGE:
      isDisable = disableOrder[PAYMENT_METHOD.PACKAGE]
      break
    case PAYMENT_METHOD.BANK_TRANSFERS:
      isDisable = disableOrder[PAYMENT_METHOD.BANK_TRANSFERS]
      break
    case PAYMENT_METHOD.CARD:
      isDisable = disableOrder[PAYMENT_METHOD.CARD]
      break
    case PAYMENT_METHOD.POST_PAID:
      isDisable = disableOrder[PAYMENT_METHOD.POST_PAID]
      break
    default:
      isDisable = false
      break
  }

  const onClose = () => {
    setShowInfoTransfer(false)
    dispatch(resetStore())
    dispatch(changeFragment())
    navigate(
      `${COMPONENTS.userManagement.components.subscriptionPayment.components.orderDetail.route}?orderId=${dataBankTransfer?.orderId}`,
    )
  }

  const onPlaceOrder = () => {
    if (method !== PAYMENT_METHOD.PACKAGE) {
      setIsValid({
        phone: checkPhoneValid(userInfo.phone, false),
        invoiceReceivingEmail: checkEmailValid(userInfo.invoiceReceivingEmail),
        customerName: !!userInfo.customerName,
        companyName: !!userInfo.companyName,
        companyAddress: !!userInfo.companyAddress,
        taxCode: !!userInfo.taxCode,
      })

      if (
        !checkPhoneValid(userInfo.phone) ||
        !checkEmailValid(userInfo.invoiceReceivingEmail) ||
        !Boolean(userInfo.customerName) ||
        !Boolean(userInfo.companyName) ||
        !Boolean(userInfo.companyAddress) ||
        !Boolean(userInfo.taxCode) ||
        !Boolean(userInfo.phone)
      ) {
        return
      }
    }

    if (method === PAYMENT_METHOD.PACKAGE) {
      if (
        !isExistDataBlock &&
        ![USER_TYPE.PREMIUM, USER_TYPE.STANDARD].includes(userType.userTypeId)
      ) {
        return
      }
      setShowInvalidPackage(true)
    }
    if (isDisable || !isFullCriteria) return

    dispatch(
      postOrder(
        isScreening
          ? {
              order: {
                details: [
                  {
                    screeningCriteria: JSON.stringify(paramsScreeningReport),
                    rawScreeningCriteria: JSON.stringify(rawCriteria),
                    numOfCompanies: numberCompany,
                    screeningLanguageCode: languageCode || locale,
                    price: screeningPrice?.price,
                    discountId: screeningPrice?.discountId || undefined,
                    discountPercentage:
                      screeningPrice?.discountPercentage || undefined,
                  },
                ],
                discountId: discountInfo?.id ? discountInfo?.id : undefined,
                discountPercentage: discountInfo?.id
                  ? discountInfo?.discountPercentage
                  : undefined,
                voucherCode: discountInfo?.voucherCode || undefined,
                paymentMethod: PAYMENT_METHOD_CODE[method],
                paymentCurrency: unitBank,
                ...userInfoFormat,
              },
            }
          : {
              order: {
                details: [...dataItemCart],
                discountId: checkDiscountAndVoucher[
                  CHECKBOX_TRADE_DISCOUNT.DISCOUNT
                ]
                  ? discountOrder?.id
                  : undefined,
                voucherCode: checkDiscountAndVoucher[
                  CHECKBOX_TRADE_DISCOUNT.VOUCHER
                ]
                  ? voucher?.code
                  : undefined,
                paymentMethod: PAYMENT_METHOD_CODE[method],
                paymentCurrency: unitBank,
                ...userInfoFormat,
              },
            },
      ),
    )
      .unwrap()
      .then((result) => {
        const { orderId: idOder, transactionCode: code } = result
        if (method === PAYMENT_METHOD.CARD) {
          authProvider.getUser().then((user) => {
            window.open(
              `${process.env.REACT_APP_SERVICE_ENDPOINT}/Transaction/PaymentCardRedirect?PaymentGate=${bankTransferType}&TransactionCode=${code}&access_token=${user.access_token}`,
              '_self',
            )
          })
          return
        }
        if (method === PAYMENT_METHOD.BANK_TRANSFERS) {
          dispatch(
            getBankTransferInfo({
              TransactionCode: code,
              CurrencyCode: unitBank,
            }),
          )
            .unwrap()
            .then(() => {
              setShowInfoTransfer(true)
            })
            .catch(() => {})
          return
        }
        dispatch(changeFragment())
        navigate(
          `${COMPONENTS.cartAndOrders.route}?step=${
            STEP.ORDER_CONFIRMATION
          }&PaymentStatus=${
            method === PAYMENT_METHOD.POST_PAID
              ? TYPE_STATUS_ORDER.PENDING
              : TYPE_STATUS_ORDER.PAID
          }&TransactionCode=${code}&OrderId=${idOder}`,
        )
        dispatch(resetStore())
        if (isScreening) {
          dispatch(resetStoreScreening())
        }
      })
      .catch(({ error }) => {
        if (error.status === 400) {
          EventEmitter.dispatch(SHOW_POPUP_ERROR, {
            messages: error.data.errors,
          })

          return
        }

        navigate(
          `${COMPONENTS.cartAndOrders.route}?step=${STEP.ORDER_CONFIRMATION}&PaymentStatus=${TYPE_STATUS_ORDER.UNPAID}`,
        )
        dispatch(resetStore())
        if (isScreening) {
          dispatch(resetStoreScreening())
        }
      })
  }

  return (
    <>
      <Element
        style={{
          backgroundColor: '#3DA967',
          color: '#FFFFFF',
          pointerEvents:
            method === PAYMENT_METHOD.PACKAGE && isExistDataBlock
              ? ''
              : loadingOrder ||
                isDisable ||
                !isCheckRules ||
                !checkValidForm ||
                !isFullCriteria ||
                (!isExistDataBlock &&
                  method === PAYMENT_METHOD.PACKAGE &&
                  ![USER_TYPE.PREMIUM, USER_TYPE.STANDARD].includes(
                    userType.userTypeId,
                  ))
              ? STYLE_DISABLE.pointerEvents
              : '',
          opacity:
            method === PAYMENT_METHOD.PACKAGE && isExistDataBlock
              ? ''
              : loadingOrder ||
                isDisable ||
                !isCheckRules ||
                !checkValidForm ||
                !isFullCriteria ||
                (!isExistDataBlock &&
                  method === PAYMENT_METHOD.PACKAGE &&
                  ![USER_TYPE.PREMIUM, USER_TYPE.STANDARD].includes(
                    userType.userTypeId,
                  ))
              ? STYLE_DISABLE.opacity
              : '',
        }}
        className={`${classes.btnSubmit} positionRelative`}
        onClick={onPlaceOrder}
      >
        {loadingOrder && <Loading />}
        <Image
          src={chaseMoneyIcon}
          alt="chaseMoney"
          style={{ width: 18, height: 18 }}
          className={classes.mr4}
        />
        <Translate value="cartAndOrders.orderInformation.placeOrder" />
      </Element>
      {iShowInfoTransfer && (
        <TransferInformationPopup
          isShow={iShowInfoTransfer}
          onClose={onClose}
          type={unitBank}
        />
      )}
    </>
  )
}
